import { render, staticRenderFns } from "./home.vue?vue&type=template&id=3c6e74e0&"
import script from "./home.component.ts?vue&type=script&lang=ts&"
export * from "./home.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports